import { render } from "./bookmark_timeline.vue?vue&type=template&id=2731376e"
import script from "./bookmark_timeline.js?vue&type=script&lang=js"
export * from "./bookmark_timeline.js?vue&type=script&lang=js"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__